import { TABLES } from "./schema";

const DEFAULT_TRANSACTION_TABLES = [
  TABLES.ORGANIZATIONS,
  TABLES.VESSELS,
  TABLES.VESSEL_PARTICULARS,
  TABLES.TANKS,
  TABLES.VOYAGES,
  TABLES.TRIPS,
  TABLES.TRIP_CARGO,
  TABLES.AUDIT_ENTRIES,
  TABLES.SYNC_OPERATIONS,
  TABLES.CREDENTIAL_PACKAGES,
  TABLES.LOCAL_SESSIONS,
  TABLES.VESSEL_INSTALLATIONS,
];

export const runLocalTransaction = async (
  db,
  callback,
  tableNames = DEFAULT_TRANSACTION_TABLES
) => {
  const tables = tableNames.map((tableName) => db.table(tableName));
  return db.transaction("rw", tables, callback);
};
